import PropTypes from 'prop-types'
import ScenicAccordion from '@components/scenic-accordion'
import FullheightTablist from '@components/fullheight-tablist'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useStyles from './member-benefits.styles'

const MemberBenefits = (props) => {
  const styles = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={styles.memberBenefits}>
      { isMobile ? <ScenicAccordion {...props} /> : <FullheightTablist {...props} /> }
    </div>
  )
}

MemberBenefits.propTypes = {}

MemberBenefits.defaultProps = {}

export default MemberBenefits
